
// Customer Say Slider

$('.customer_SaySlider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  arrows: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        arrows: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        arrows: true
      }
    },
    {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          arrows: true // or false if you want to hide arrows on mobile
        }
      }
  ]
});

// Trusted Client Mobile Slider

$('.trusted_mob_slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  arrows: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        arrows: true
      }
    },
    {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          arrows: true // or false if you want to hide arrows on mobile
        }
      }
  ]
});


